// Centralized brand & content constants for My Hoom

export const BRAND = {
  name: "My Hoom",
  tagline: "Find the right move for your future",
  secondaryTagline: "Making Real Estate Simpler, Smarter, More Rewarding",
  phoneIN: "+91 90086 83300",
  phoneINraw: "+919008683300",
  phoneAE: "+971 XX XXX XXXX",
  email: "help@myhoom.in",
  whatsappURL: "https://wa.me/919008683300",
  socials: {
    instagram: "https://www.instagram.com/myhoom_blr.dxb/",
    linkedin: "https://www.linkedin.com/company/my-hoom/?viewAsMember=true",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Markets", to: "/markets" },
  { label: "Research", to: "/research" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  heroDubai: "https://images.pexels.com/photos/19612315/pexels-photo-19612315.jpeg",
  dubaiAerial: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1800&q=80",
  bengaluru: "https://images.pexels.com/photos/14845309/pexels-photo-14845309.jpeg",
  interior: "https://images.pexels.com/photos/8135492/pexels-photo-8135492.jpeg",
  apartment: "https://images.pexels.com/photos/8082227/pexels-photo-8082227.jpeg",
  advisory: "https://images.pexels.com/photos/8463151/pexels-photo-8463151.jpeg",
  office: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80",
  bengaluruCity: "https://images.unsplash.com/photo-1597030330821-cd1cc7afa9bd?auto=format&fit=crop&w=1800&q=80",
};
